export default __webpack_public_path__ + "static/media/2446.8b374fa3.png";